import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {COUNTRY_CODES} from '../../../../constants/countries';
import {FORBIDDEN_DOMAIN_EMAILS} from '../../../../constants/forbidden-emails';
import {Store} from '@ngrx/store';
import {State} from 'src/app/store';
import * as actions from '../../../../store/auth/authentication.actions';
import * as selectors from '../../../../store/auth/authentication.selectors';
import {ActivatedRoute} from '@angular/router';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';
import * as appActions from '../../../../store/app/app.actions';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../store/auth/authentication.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy, AfterViewChecked {
  register_form: FormGroup;
  country_codes: any[] = COUNTRY_CODES;
  register_spinner = false;
  error_message = '';
  platformBrandLogo = '';
  platformName = '';
  platformLandingPage = '';
  viewport = '';

  terms = '';
  policy = '';

  currencies = [];
  subscriptions = [];

  constructor(
    private store: Store<State>,
    private activatedRouter: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private _authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.store.select(selectAppViewPort).subscribe(result => {
      this.viewport = result;
    });
    this.subscriptions.push(
        this._authenticationService.getPublicCurrencies().subscribe( response => {
          this.currencies = response;
          }, () => {
        })
    );
    this.store.dispatch(appActions.getPublicUserGroup({typeUserGroup: 'platform_id',  queryValue: environment.platform_id }));
    const hash_email = this.activatedRouter.params['value'].email;
    if (hash_email) {
      this.store.dispatch(actions.getEmailFromHash({ hash: hash_email }));
    }
    this.register_form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
        ),
      ]),
      'custom:first_name': new FormControl('', [
        Validators.required,
      ]),
      'custom:language': new FormControl('ES', [
        Validators.required,
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
        ),
      ]),
      confirm_password: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
        ),
      ]),
      'custom:type_user': new FormControl('', [Validators.required]),
      phone_code: new FormControl('44', [Validators.required]),
      phone_number: new FormControl('', [
        Validators.required,
        Validators.pattern('([0-9]{6,25})'),
      ]),
      'custom:currencyType': new FormControl('', [
        Validators.required,
      ]),
      'custom:privacy_policy': new FormControl(false, [
        Validators.requiredTrue,
      ]),
      'custom:newsletter': new FormControl(false),
      recaptcha: new FormControl(null, Validators.required),
    });
    this.register_form.controls['custom:currencyType'].setValue('USD');
    // Set custom validators for password & confirm_password fields
    this.register_form.controls['email'].setValidators([
      Validators.required,
      Validators.pattern(
        "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
      ),
      this.checkIfEmailIsForbidden.bind(this),
    ]);
    this.register_form.controls['password'].setValidators([
      Validators.required,
      Validators.pattern(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
      ),
      this.checkPasswordNewPassword.bind(this),
    ]);
    this.register_form.controls['confirm_password'].setValidators([
      Validators.required,
      Validators.pattern(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z]|[^ ]){8,}$'
      ),
      this.checkPassword.bind(this),
    ]);
    this.subscriptions.push(
      this.store
        .select(selectors.selectSignUpLoading)
        .subscribe(loading => (this.register_spinner = loading)),
      this.store
        .select(selectors.selectSignUpError)
        .subscribe(error => (this.error_message = error)),
      this.store.select(selectors.selectEmailFromHash).subscribe(result => {
        if (result === null) {
          result = '';
        }
        this.register_form.controls['email'].setValue(result);
      }),
    );
  }

  ngAfterViewChecked() {
    this.subscriptions.push(
        this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
          if (userGroup !== null ) {
            this.platformBrandLogo = userGroup.logo_login_url;
            this.platformName = userGroup.platform_name;
            this.platformLandingPage = userGroup.landing_page;
            this.terms = userGroup.terms_and_conditions_en;
            this.policy = userGroup.privacy_policy_en;
            this.cdr.detectChanges();
          }
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.store.dispatch(actions.clearErrors());
  }

  register() {
    if (this.register_form.status !== 'INVALID') {
      this.register_form.controls['email'].setValue(
        this.register_form.controls['email'].value.toLowerCase()
      );
      this.store.dispatch(
        actions.signUp({ request: this.register_form.value })
      );
    }
  }

  /**
   * Checks if passwords match
   * @returns {boolean} If passwords match return true, else return false
   */
  checkPasswordsMatch() {
    const PASSWORD_VALUE = this.register_form.controls['password'].value;
    const CONFIRM_PASSWORD_VALUE = this.register_form.controls[
      'confirm_password'
    ].value;
    return PASSWORD_VALUE === CONFIRM_PASSWORD_VALUE && PASSWORD_VALUE !== '';
  }
  /**
   * Checks if password and confirm password are a match.
   * If passwords don't match the form becomes invalid
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkPassword(control: FormControl): object | null {
    if (control.value !== this.register_form.controls['password'].value) {
      return {
        no_equal: true,
      };
    }
    return null;
  }
  /**
   * Checks if password and confirm password are a match.
   * If passwords don't match the form becomes invalid
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkPasswordNewPassword(control: FormControl): object | null {
    if (
      control.value !== this.register_form.controls['confirm_password'].value
    ) {
      this.register_form.get('confirm_password').setErrors({
        no_equal: true,
      });
    } else if (
      control.value === this.register_form.controls['confirm_password'].value
    ) {
      this.register_form.get('confirm_password').setErrors(null);
    }
    return null;
  }
  /**
   * Check if email is forbidden and sets error if so
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkIfEmailIsForbidden(control: FormControl): object | null {
    this.register_form.get('confirm_password').setErrors(null);
    for (
      let domain_index = 0;
      domain_index < FORBIDDEN_DOMAIN_EMAILS.length;
      domain_index++
    ) {
      if (
        control.value.includes(FORBIDDEN_DOMAIN_EMAILS[domain_index]) === true
      ) {
        return {
          forbidden_email: true,
        };
      }
    }
    return null;
  }
  /**
   * Check if phone number is empty if so return a empty string else return phone number with phone code
   * @param {string} phone_number Phone number value without code
   * @return {string} phone_number_value Phone number value
   */
  checkIfPhoneIsEmpty(phone_number: string): string {
    const prefix = '+';
    const phone_code = this.register_form.controls['phone_code'].value;
    let phone_number_value = '';
    if (phone_number.length !== 0) {
      phone_number_value = prefix + phone_code + phone_number;
    } else {
      phone_number_value = '+440000000';
    }
    return phone_number_value;
  }
}
